import { Component, ErrorInfo, FC, PropsWithChildren, ReactElement } from 'react';

import { store } from 'store';
import { postError } from 'store/errorSlice';

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<PropsWithChildren<any>, ErrorBoundaryState> {
  constructor(props: PropsWithChildren<any>) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    store.dispatch(postError({ error, errorInfo }));
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    return (
      <>
        {!this.state.error && this.props.children}
        {this.state.error && <ErrorPage />}
      </>
    );
  }
}

const ErrorPage: FC = (): ReactElement => {
  return (
    <div className="tw-heading-md tw-flex tw-h-full tw-flex-col tw-content-center tw-justify-center tw-text-center">
      <h1 className="tw-heading-xl tw-pb-8">Tillfälligt fel</h1>
      <p>Tjänsten är inte tillgänglig på grund av ett tekniskt fel.</p>
      <p>Var god försök igen senare.</p>

      <p className="tw-mt-4">
        Kvarstår problemet kontakta{' '}
        <a className="raa-link" href="mailto:bebyggelseregistret@raa.se">
          bebyggelseregistret@raa.se
        </a>
      </p>
    </div>
  );
};

export default ErrorBoundary;
